import React from 'react';
import { useHistory } from 'react-router-dom';
import { Skeleton, Typography } from '@mui/material';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';
import useResourceCount from 'new/hooks/adapters/useResourceCount';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { Button } from 'new/elements/Button';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { FlowRunsScreen } from 'new/components/monitor/Runs';
import { GET_RESOURCE_COUNT_REQUEST } from 'js/constants/actionTypes';
import styles from './WelcomeBanner.module.scss';

export const WelcomeBanner = () => {
  const history = useHistory();
  const { full_name } = useCurrentUser();
  const firstName = full_name?.split(' ')?.[0];
  const resourceCount = useResourceCount('user');
  const isLoading = useIsLoading(GET_RESOURCE_COUNT_REQUEST);

  const sourcesCount = resourceCount?.data_sources?.total ?? 0;
  const destinationsCount = resourceCount?.data_sinks?.total ?? 0;
  const nexsetsCount =
    (resourceCount?.data_sets?.derived?.total ?? 0) +
    (resourceCount?.data_sets?.detected?.total ?? 0);

  const dateString = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <Typography variant="caption" className={styles.date}>
          {dateString}
        </Typography>
        <Typography variant="h5" className={styles.greeting}>
          Welcome back, <span className={styles.name}>{firstName}</span>
        </Typography>
        {isLoading ? (
          <>
            <Skeleton variant="text" width={340} height={20} />
            <Skeleton variant="text" width={340} height={20} />
          </>
        ) : (
          <Typography variant="body2" className={styles.description}>
            Your data ecosystem is humming. {sourcesCount} sources flowing into {destinationsCount}{' '}
            destinations across {nexsetsCount} Nexsets.
          </Typography>
        )}
      </div>
      <div className={styles.actions}>
        <Button
          variant="outlined"
          onClick={() => history.push(FlowRunsScreen.screenConfig.path as string)}
        >
          View activity
        </Button>
        <Button
          variant="contained"
          className={styles.createButton}
          onClick={() => history.push(`${ROUTE_REDESIGN}${ROUTE_CONNECT}/flows?action=create`)}
        >
          Create Flow
        </Button>
      </div>
    </div>
  );
};
